export default "__VITE_PUBLIC_ASSET__a78a336b__"